// Module
var code = "<fieldset class=datetimepicker ng-disabled=ngDisabled> <date-picker name=dateInput ng-model=model.date ng-change=changeDate()></date-picker> <nlg-timepicker name=timeInput ng-model=model.time ng-change=changeTime()></nlg-timepicker> </fieldset>";
// Exports
module.exports = code;